export function ShotokuEpigraph() {
  return (
    <figure
      data-testid="shotoku-epigraph"
      style={{
        maxWidth: 640,
        margin: "40px auto 20px",
        padding: "0 24px",
        textAlign: "center",
      }}
    >
      <blockquote
        style={{
          margin: 0,
          fontFamily: '"Playfair Display", "Fraunces", Georgia, serif',
          fontStyle: "italic",
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 1.6,
          color: "var(--qv3-grey-500)",
          letterSpacing: "-0.005em",
        }}
      >
        « Les affaires importantes ne doivent pas être tranchées par un seul ;
        elles doivent être débattues avec le plus grand nombre. »
      </blockquote>
      <figcaption
        style={{
          marginTop: 8,
          fontFamily: '"Playfair Display", "Fraunces", Georgia, serif',
          fontStyle: "italic",
          fontSize: 12,
          color: "#FF1744",
          letterSpacing: "0.02em",
        }}
      >
        — Prince Shōtoku, Constitution en dix-sept articles, article XVII, 604
      </figcaption>
    </figure>
  );
}

export default ShotokuEpigraph;
